import styled from "styled-components";
import { Card } from "../card";

export const LineGraphWrapper = styled(Card)(({ bgColor }) => {
  return {
    backgroundColor: "var(--color-background)",
    color: "var(--color-text)",
    marginBlock: "var(--sectionMargin)",
  };
});
